<template>
<!-- 新增角色 -->
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="650px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div class="from-body">
        <el-form
          :model="params"
          ref="ruleForm"
          label-width="auto"
          class="demo-ruleForm"
          :rules="rules"
        >
          <el-form-item :label="$t('pages.system.text91')" prop="roleName">
            <el-input
              v-model="params.roleName"
              :disabled="isAdd == 3 ? true : false"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('pages.system.text124')" prop="roleDesc">
            <el-input
              type="textarea"
              rows="4"
              :disabled="isAdd == 3 ? true : false"
              v-model="params.roleDesc"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('pages.system.text125')">
            <el-button
              type="primary"
              @click="jurisdiction = true"
              icon="el-icon-s-tools"
              >{{ isAdd == 3 ? $t('button.look') : $t('button.pleaseSelect') }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{
          isAdd == 3 ? $t('button.close') : $t('button.cancel')
        }}</el-button>
        <el-button type="primary" v-if="isAdd != 3" @click="submit"
          >{{$t('button.determine')}}</el-button
        >
      </span>
    </el-dialog>

    <el-drawer
      :title="$t('pages.system.text126')"
      :before-close="jurisdictionClose"
      :visible.sync="jurisdiction"
      direction="rtl"
      custom-class="demo-drawer"
      ref="drawer"
    >
      <div class="demo-drawer__content">
        <div class="jurisdiction-content">
          <el-tree
            ref="tree"
            :data="data"
            :show-checkbox="isAdd == 3 ? false : true"
            node-key="id"
            :check-strictly="iStrictly"
            default-expand-all
            :props="defaultProps"
            :default-checked-keys="checkedKeys"
          >
          </el-tree>
        </div>
        <div class="demo-drawer__footer">
          <el-button @click="jurisdictionClose">{{
            isAdd == 3 ? $t('button.close') : $t('button.cancel')
          }}</el-button>
          <el-button type="primary" v-if="isAdd != 3" @click="submitSelect"
            >{{$t('button.determine')}}</el-button
          >
        </div>
      </div>
    </el-drawer>
  </div>
</template>


<script>
import { validatName, validatDescribe } from "../../../../utils/util/test";
import { mapState } from "vuex";
export default {
  data() {
    return {
      iStrictly: true, //父子是否关联
      params: {
        belongCustomerId: "", //客户id
        buttonIds: [], //按钮ids
        roleDesc: "", //	角色描述
        menuIds: [], //菜单ids
        roleCode: "", //角色code
        roleName: "", //角色名称
        sort: 0, //排序
        status: 0,
      },
      title:this.$t('pages.system.text123'),
      checkedKeys: [],
      data: [],
      defaultProps: {
        children: "children",
        label: "menuName",
      },
      jurisdiction: false,
      rules: {
        roleName: [{ validator: validatName, trigger: "blur" }],
        roleDesc: [{ validator: validatDescribe, trigger: "blur" }],
      },
    };
  },
  computed: {
    ...mapState(["platformData"]),
  },
  watch: {
    dialogVisible(newValue) {
      if (newValue) {
        this.params.buttonIds = [];
        this.params.roleDesc = "";
        this.params.menuIds = [];
        this.params.roleName = "";

        if (this.isAdd == 1) {
          this.title = this.$t('pages.system.text123')
          this.listWithButtons(
            "accountId=" + JSON.parse(localStorage.getItem("userInfo")).id
          );
          this.iStrictly = false;
          //新增
        } else if (this.isAdd == 2) {
          this.title = this.$t('button.edit')+ this.$t('pages.system.text70')
          this.listWithButtons(
            "accountId=" + JSON.parse(localStorage.getItem("userInfo")).id
          );
          //编辑
          this.params.buttonIds = this.currentRole.buttonIds;
          this.params.roleDesc = this.currentRole.roleDesc;
          this.params.menuIds = this.currentRole.menuIds;
          this.params.roleName = this.currentRole.roleName;
          this.params.id = this.currentRole.id;
          this.checkedKeys = [
            ...this.currentRole.menuIds,
            ...this.currentRole.buttonIds,
          ];
          this.iStrictly = true;
        } else {
          this.title = this.$t('button.look')+ this.$t('pages.system.text70')
          this.data = this.currentRole.treeList;
          this.params.buttonIds = this.currentRole.buttonIds;
          this.params.roleDesc = this.currentRole.roleDesc;
          this.params.menuIds = this.currentRole.menuIds;
          this.params.roleName = this.currentRole.roleName;
          //查看
        }
      }
    },
  },
  props: ["dialogVisible", "isAdd", "currentRole"],
  mounted() {},
  methods: {
    appendForArrChild(arr) {
      for (let i in arr) {
        arr[i].disabled = true;
        if (arr[i].children && arr[i].children.length > 0) {
          this.appendForArrChild(arr[i].children);
        }
      }
      return arr;
    },
    removedForArrChild(arr) {
      for (let i in arr) {
        arr[i].disabled = false;
        if (arr[i].children && arr[i].children.length > 0) {
          this.removedForArrChild(arr[i].children);
        }
      }
      return arr;
    },
    //取消
    handleClose() {
      this.data = this.removedForArrChild(this.data);
      this.$refs["ruleForm"].resetFields();
      // this.$refs.tree.setCheckedKeys([]);
      if(this.$refs.tree){
        this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys([]);
      });
      }
      
      this.$emit("dialogClose");
    },
    //获取菜单列表
    listWithButtons(params) {
      this.request.listWithButtons(params).then((res) => {
        this.data = res.data;
      });
    },
    //关闭权限弹窗
    jurisdictionClose() {
      this.jurisdiction = false;
    },
    //权限弹窗提交
    submitSelect() {
      let arrayId = this.$refs.tree
        .getCheckedKeys()
        .concat(this.$refs.tree.getHalfCheckedKeys());
      let arr1 = [];
      let arr2 = [];
      for (let i in arrayId) {
        if (arrayId[i] > 0) {
          arr1.push(arrayId[i]);
        } else {
          arr2.push(Math.abs(arrayId[i]));
        }
      }
      this.params.menuIds = arr1;
      this.params.buttonIds = arr2;
      // console.log(arr2);
      console.log(arr1);
      this.jurisdictionClose();
    },
    //确定
    submit() {
      this.params.belongCustomerId = this.platformData.id;
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.params.menuIds.length < 1) {
            return this.$message.error(this.$t('pages.system.text127'));
          }
          if (this.isAdd == 1) {
            this.request.roleManagementAdd(this.params).then(() => {
              this.$message.success(this.$t('pages.system.text128'));
            });
          } else {
            this.request.roleManagementEdit(this.params).then(() => {
              this.$message.success(this.$t('pages.system.text129'));
            });
          }
          setTimeout(() => {
            this.$emit("roleManagementList");
            this.handleClose();
          }, 500);
        }
      });
    },
  },
};
</script>

<style scoped>
.from-body {
  padding: 0 40px;
  box-sizing: border-box;
}
.demo-drawer__content {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  padding-top: 0;
}
.jurisdiction-content {
  flex: 1;
  margin-top: 20px;
}
.demo-drawer__footer {
  padding: 20px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
}
.top-switch {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-around;
}
</style>